import axiosLib from "axios";

const axios = ({
  method = "get",
  url,
  data = {},
  headers = {},
  signal,
  timeout,
}) => {
  return axiosLib({
    method,
    url,
    data,
    headers,
    signal,
    timeout,
  });
};

export default axios;
